import { LucideIcon } from "lucide-react";
import { CYCLE_BANNER_CLASS_NAME, PRIMARY_HEX } from "../constants";

export interface CycleBannerItem {
  label: string;
  value: string;
  detail?: string;
  Icon: LucideIcon;
}

interface CycleBannerProps {
  items: readonly CycleBannerItem[];
}

export function CycleBanner({ items }: CycleBannerProps): JSX.Element {
  return (
    <div
      className={`grid w-full grid-cols-2 gap-4 lg:grid-cols-4 ${CYCLE_BANNER_CLASS_NAME}`}
    >
      {items.map((item: CycleBannerItem) => (
        <div key={item.label} className="flex items-start gap-3">
          <item.Icon className="mt-0.5 h-5 w-5 shrink-0" color={PRIMARY_HEX} />
          <div className="min-w-0">
            <p className="text-xs font-medium text-gray-500">{item.label}</p>
            <p className="truncate text-lg font-bold text-[#613F4F]">
              {item.value}
            </p>
            {item.detail && (
              <p className="text-xs text-gray-500">{item.detail}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
